<template>
	<body v-if="isLogin" class="hold-transition sidebar-mini layout-navbar-fixed">
		<div class="wrapper">
			<!-- <ThePreLoader></ThePreLoader> -->
			<TheNavBar></TheNavBar>
			<TheSideBar></TheSideBar>
			<div class="content-wrapper">
				<TheContentHeader></TheContentHeader>
				<section class="content">
					<div class="container-fluid">
						<router-view></router-view>
					</div>
				</section>
			</div>
			<TheFooter></TheFooter>
			<TheControlSideBar></TheControlSideBar>
		</div>
	</body>
</template>

<script>
	// eslint-disable-next-line
	import ThePreLoader from '../dashboard/ThePreloader.vue'
	import TheContentHeader from '../dashboard/TheContentHeader.vue'
	import TheNavBar from '../dashboard/TheNavBar.vue'
	import TheSideBar from '../dashboard/TheSideBar.vue'
	import TheFooter from '../dashboard/TheFooter.vue'
	import TheControlSideBar from '../dashboard/TheControlSidebar.vue'

	import { mapState } from 'vuex';

	export default {
		name: 'TheLoggedInLayout',
		data() {
			return {
				isLogin: false
			}
		},
		components: {
			ThePreLoader,
			TheContentHeader,
			TheNavBar,
			TheSideBar,
			TheFooter,
			TheControlSideBar
		},
		computed: {
			...mapState({
				user: state => state.authentication
			}),
		},
		mounted() {
			// this.isLogin = this.user.status.loggedIn;
			let user = JSON.parse(localStorage.getItem('user'));
			this.isLogin = user ? true : false
		}
	};
</script>

<style></style>
